import { IconName } from '@travelata-libs/ui-kit';
import { ConfirmationType, type ConfirmationDetail } from '../model/types';

export const CONFIRMATION_TYPE_TITLES: Record<ConfirmationType, string> = {
  [ConfirmationType.Quick]: 'Быстрое подтверждение',
  [ConfirmationType.Long]: 'Выгодно, если подождать',
  [ConfirmationType.Cancel]: 'Есть вероятность отмены',
};

// Неразрывные пробелы стоят там же, где в макете: они держат перенос строки на месте.
export const CONFIRMATION_TYPE_DETAILS: Record<ConfirmationType, readonly ConfirmationDetail[]> = {
  [ConfirmationType.Quick]: [
    { icon: IconName.ShieldCheck, text: 'Тур с гарантированными местами от туроператора' },
    { icon: IconName.CircleCheck, text: 'Быстро подтверждается' },
    { icon: IconName.PlayerTrackNext, text: 'Раскупают быстрее всего' },
  ],
  [ConfirmationType.Long]: [
    { icon: IconName.Discount, text: 'Часто это предложение по лучшей цене' },
    { icon: IconName.Clock, text: 'Туроператор подтверждает тур дольше чем обычно' },
    { icon: IconName.Clock72, text: 'Среднее время подтверждения 72 часа' },
    { icon: IconName.RotateClockwise, text: 'Если тур не подтвердится - предложим замену или вернём деньги' },
  ],
  [ConfirmationType.Cancel]: [
    { icon: IconName.Discount, text: 'Такие туры часто стоят дешевле аналогов' },
    { icon: IconName.Ban, text: 'Есть риск, что туроператор не подтвердит данный тур' },
    { icon: IconName.ClockExclamation, text: 'Время подтверждения более 72 часов' },
    { icon: IconName.RotateClockwise, text: 'Если тур не подтвердится - предложим замену или вернём деньги' },
  ],
};

export const CONFIRMATION_TYPE_SHEET_TEXTS = {
  close: 'Понятно',
} as const;
